<div class="flex flex-col items-center justify-center h-full w-full overflow-auto bg-default-background confirm-open-container">
  <div class="flex flex-col items-center rounded bg-white max-w-80 confirm-open-inner-container">
    <ng-container *ngIf="requireSecurityCode">
      <mat-stepper #stepper>
        <!-- Required: Material draws these three states as Material Icons ligatures, and that font is
             gone. See src/app/shared/material-internal-icons.spec.ts. -->
        <ng-template matStepperIcon="done"><mat-icon svgIcon="ph-regular-check"></mat-icon></ng-template>
        <ng-template matStepperIcon="edit"><mat-icon svgIcon="ph-regular-pencil-simple"></mat-icon></ng-template>
        <ng-template matStepperIcon="error"><mat-icon svgIcon="ph-regular-warning"></mat-icon></ng-template>
        <mat-step>
          <ng-container *ngTemplateOutlet="securityCodeTemplate"/>
          <div class="flex flex-col flex-wrap justify-center w-full gap-2 mt-2">
            <button mat-raised-button matStepperNext color="primary" [disabled]="securityCode?.length != 3">Continuar</button>
            <button mat-stroked-button mat-dialog-close (click)="close()">{{ 'components.confirm_open.back_button' | translate }}</button>
          </div>
        </mat-step>
        <mat-step>
          <ng-container *ngTemplateOutlet="openTemplate"/>
        </mat-step>
      </mat-stepper>
    </ng-container>
    <ng-container *ngIf="!requireSecurityCode">
      <ng-container *ngTemplateOutlet="openTemplate"/>
    </ng-container>
  </div>
</div>

<ng-template #openTemplate>
  <ng-container *ngIf="store?.storeType !='COFFEE'">
    <h2 class="text-default-gray text-xl font-bold text-center mt-3 mb-5 mx-4">{{ 'components.confirm_open.title' | translate }}</h2>
    <div class="flex justify-center items-center p-2 h-40">
      <ng-lottie [options]="{ path: '/assets/animations/open.json', loop: true }"/>
    </div>
  </ng-container>
  <ng-container *ngIf="store?.storeType =='COFFEE'">
    <h2 class="text-default-gray text-xl font-bold text-center mt-3 mb-5 mx-4">{{ 'components.confirm_open.coffee_title' | translate }}</h2>
    <div class="flex justify-center items-center p-2">
      <ng-lottie [options]="{ path: '/assets/animations/connect.json', loop: true }"/>
    </div>
  </ng-container>
  <div class="flex flex-col flex-wrap justify-center w-full gap-2 mt-2 p-4">
    <span *ngIf="validationPreview?.willValidate"
      class="text-sm text-default-gray text-center mt-2"
      [innerHTML]="(validationPreview?.isPreAuthorization ? 'components.confirm_open.validation_hold' : 'components.confirm_open.validation_charge') | translate:{ amount: (validationPreview!.amount | currencyClp) }">
    </span>
    <button mat-raised-button color="primary" (click)="confirmOpen()">{{ 'components.confirm_open.confirm_button' | translate | uppercase }}</button>
    <button mat-stroked-button mat-dialog-close (click)="close()">{{ 'components.confirm_open.back_button' | translate | uppercase }}</button>
  </div>
</ng-template>

<ng-template #securityCodeTemplate>
  <div class="flex flex-col justify-center items-center">
    <div class="w-full">
      <app-fancy-card-back [securityCode]="securityCode"></app-fancy-card-back>
    </div>
    <div class="flex justify-center w-full pb-5">
      <mat-form-field class="w-full my-2" appearance="outline">
        <mat-label>Código de seguridad</mat-label>
        <input type="password" maxlength="4" matInput [(ngModel)]="securityCode">
        <mat-hint class="text-light-gray" align="start">
          Ingresa el código de seguridad para validar tu identidad.
        </mat-hint>
      </mat-form-field>
    </div>
  </div>
</ng-template>
